import { routerHandlers } from "./router";
import { settingsHandlers } from "./settings";
import { techUiHandlers } from "./tech-ui";

// Settings handlers precede the tech-ui ones so the settings `/enums/` variant
// is matched before the tech-ui shell's bare `/enums/` fall-through handler.
const handlers = [...routerHandlers, ...settingsHandlers, ...techUiHandlers];

export { handlers };
